<template>
<div :class="{'d-flex': horizontal}">
	<div v-if="item.type == 'user' || item.type == 'equipment'">
		{{item.description}}
	</div>
	<template v-else>
		<div v-if="displayFields.indexOf('entityName') >= 0" v-html="stripInlineEventHandlers(item.description)" :class="{'mr-1': horizontal}"></div>
		<div v-if="displayFields.indexOf('startEndTime') >= 0 && isJobEvent" :class="{'mr-1': horizontal}">
			<template v-if="daysDuration > 1">
				{{item.startMoment.format("dd hh:mm A")}} - {{item.endMoment.format("dd hh:mm A")}}
			</template>
			<template v-else-if="isAllDay">All Day</template>
			<template v-else>
				{{item.startMoment.format("hh:mm A")}} - {{item.endMoment.format("hh:mm A")}}
			</template>
			<br v-if="item.attachedJobDescription">
			{{item.attachedJobDescription}}
		</div>
		<div v-if="displayFields.indexOf('customerName') >= 0 && item.type != 'user' && item.type != 'equipment'" :class="{'mr-1': horizontal}">

			<template v-if="'Service' in item && item.Service && 'Customer' in item.Service && item.Service.Customer">
				{{ item.Service.Customer.name }}
			</template>
			<template v-else-if="'Job' in item && item.Job">
				<template v-if="'Customer' in item.Job && item.Job.Customer && !isInternalProject">
					{{ item.Job.Customer.name }}
				</template>
				<template v-else>
					{{item.description}}
				</template>
			</template>

		</div>
		<div v-if="displayFields.indexOf('locationAddress') >= 0" :class="{'mr-1': horizontal}">
			
			<template v-if="'Service' in item && item.Service && 'Customer' in item.Service && item.Service.Customer">
				{{ formatLocationAddress(item.Service) }}
			</template>
			<template v-else-if="'Job' in item && item.Job && 'Customer' in item.Job && item.Job.Customer">
				{{ formatLocationAddress(item.Job) }}
			</template>
			
		</div>
	</template>
</div>
</template>

<script type="text/javascript">
export default {
	name: "ScheduleItemTileFields",
	props: [
		"item",
		"displayFields",
		"horizontal"
	],
	computed: {
		isJobEvent() {

			if ((!("User" in this.item) || !this.item.User) && (!("Equipment" in this.item) || !this.item.Equipment) && ("Job" in this.item || "Service" in this.item))
				return true

			return false
		},
		daysDuration() {
			let hrsDuration = this.item.endMoment.diff(this.item.startMoment,"hours")

			return Math.ceil(hrsDuration / 24)
		},
		isAllDay() {
			if (this.item.duration >= 23.98 && this.item.duration <= 24)
				return true

			return false
		},
		isInternalProject() {
			if ("Job" in this.item && this.item.Job && "is_internal_project" in this.item.Job && this.item.is_internal_project == 1)
				return true
			return false
		}
	},
	methods: {
		formatLocationAddress(entity) {
			if (!entity || !entity.address)
				return ""

			if (entity.city)
				return entity.address + ", " + entity.city

			return entity.address
		}
	}
}
</script>